import { model_img } from "assets/images";
import { CustomModal } from "components/modals/ModalBox";
import TypographyLimit from "components/TypographyLimit";
import React, { useEffect, useState } from "react";
import { getReportDetailApi } from "services/report";

const ViewReport = ({ _id, onClose }) => {
  const [state, setState] = useState();

  const fetchReportDetail = async () => {
    try {
      const response = await getReportDetailApi({ _id, type: "COMMENT" });
      setState(response.data.data);
      console.log(response);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchReportDetail();
  }, []);

  const messageDetail = state?._comment;
  const groupReportList = state?.reports;

  return (
    <div>
      <CustomModal
        className={"wrap_message_modal wrap_groups_modal"}
        show={true}
        handleClose={onClose}
      >
        <h3>Comment Report Detail</h3>
        <div className="wrap_card_groups wrap_card_message">
          <div className="card_grp">
            <div className="comment_section_header">
              <div className="header_wraper">
                <img src={model_img} alt="model_images" />
                <p>
                  Posted by <span>Queen</span>
                </p>
              </div>
            </div>

            <div className="message_paragraph">
              <p>
                <TypographyLimit
                  className="card-description"
                  limit={50}
                  text={messageDetail?.content}
                  enableReadMore
                />
              </p>
            </div>
          </div>
        </div>

        <div
          style={{ maxHeight: "170px", overflowY: "auto" }}
          className="report_model_content"
        >
          {groupReportList?.map((report, index) => (
            <div key={index}>
              <div style={{ marginBottom: "10px" }}>
                <div className="report_topic">
                  <p>Report {index + 1}</p>
                </div>

                <div className="wrap_card_description">
                  <b>Description</b>
                  <p>{report?.description}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="btn_wrapper">
          <button className="button delete_btn"> Delete Comment</button>
          <button className="button remove_btn">Remove Report</button>
        </div>

        {/* <div className="button_wraper">
                    <button type="button" className="block">
                        Block Group
                    </button>
                    <button type="button" className="delete">
                        Remove Report
                    </button>
                </div> */}
      </CustomModal>
    </div>
  );
};

export default ViewReport;
